// @flow
import * as React from 'react';
import {useAccount, useApi} from 'docs/data';

import type {DataContextProps} from './GuideTypes';

const DataContext = React.createContext<DataContextProps>({
  activePrice: null,
  setActivePrice: () => {},
  taxActivationStatus: null,
  prices: [],
  setPrices: () => {},
});

type Props = {|
  children: React.Node,
|};

// TODO(mfix) consider moving this into Demo state
export const DataProvider = (props: Props) => {
  const [activePrice, setActivePrice] = React.useState(null);
  const [prices, setPrices] = React.useState([]);
  const [taxActivationStatus, setTaxActivationStatus] = React.useState(null);
  const {account} = useAccount();
  const {api} = useApi();

  const isLoggedIn = account.merchant?.isLoggedIn;
  React.useEffect(() => {
    if (isLoggedIn) {
      api.getPrices().then((res) => {
        if (res?.data?.length) {
          setPrices(res.data);
        }
      });
      api.getTaxData().then((res) => {
        if (res?.activation_status) {
          setTaxActivationStatus(res.activation_status);
        }
      });
    }
  }, [api, isLoggedIn]);

  const value = React.useMemo(
    () => ({
      activePrice,
      setActivePrice,
      prices,
      setPrices,
      taxActivationStatus,
    }),
    [activePrice, prices, taxActivationStatus],
  );

  return (
    <DataContext.Provider value={value}>{props.children}</DataContext.Provider>
  );
};

export const useData = (): DataContextProps => {
  return React.useContext(DataContext);
};
